import React, { useEffect, useRef, useState } from "react";

export interface LeagueFilters {
  nome?: string;
  username?: string;
}

export interface LeagueFilterModalProps {
  open: boolean;
  onClose: () => void;
  onFilter: (filters: LeagueFilters) => void;
}

const LeagueFilterModal: React.FC<LeagueFilterModalProps> = ({
  open,
  onClose,
  onFilter,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const [nome, setNome] = useState("");
  const [username, setUsername] = useState("");

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (open) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.classList.add("modal-open");
      modalRef.current?.focus();
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("modal-open");
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleApply = () => {
    onFilter({ nome: nome || undefined, username: username || undefined });
    onClose();
  };

  const handleReset = () => {
    setNome("");
    setUsername("");
    onFilter({});
    onClose();
  };

  return (
    <>
      <div
        className="modal-backdrop fade show"
        onClick={onClose}
        style={{ position: "fixed", inset: 0, zIndex: 1050 }}
      />
      <div
        className="modal fade show d-block"
        role="dialog"
        tabIndex={-1}
        ref={modalRef}
        onMouseDown={handleBackdrop}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1055,
          overflow: "auto",
        }}
      >
        <div
          className="modal-dialog"
          role="document"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title w-100 text-center">Filtros</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label d-block">Nome da Liga</label>
                <input
                  type="text"
                  className="form-control"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Digite o nome da liga"
                />
              </div>
              <div className="mb-3">
                <label className="form-label d-block">Username</label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Digite o username"
                />
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-link font-xsss"
                style={{ color: "#3B3B3B" }}
                onClick={handleReset}
              >
                Redefinir filtros
              </button>
              <button
                type="button"
                className="btn btn-primary font-xsss lh-38 py-2"
                onClick={handleApply}
              >
                FILTRAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeagueFilterModal;
